import React, {Component} from 'react';
// import LoadingButton from '@mui/lab/LoadingButton';
import SaveIcon from '@mui/icons-material/Save';
import { IconButton, CircularProgress, Box } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';


class SubmitButton extends Component<any,any> {
  static propTypes: any;
  static defaultProps: any;
  constructor(props:any) {
    super(props);
    const {loading} = props;
    this.state = {
      loading: loading||false,
      open: false,
    };
  }

  componentDidUpdate(prevProps:any) {
    // Check if the relevant prop has actually changed
    if (this.props.loading !== prevProps.loading) {
      // Update the internal state based on the new prop value
      this.setState({
        loading: this.props.loading
      });
    }
  }

  onClick = () => {
    this.setState({loading:true});
    const {onClick} = this.props;
    if(typeof onClick === 'function') {
      onClick();
    }
  }

  onStop = () => {
    this.setState({loading:false});
  }

  // render00() {
  //   //const { status,start,stop } = this.props;
  //   const { loading } = this.state;

  //   return (
  //   <LoadingButton
  //     onClick={this.onClick}
  //     loading={loading}
  //     endIcon={<SaveIcon />}
  //     loadingPosition="end"
  //     variant="contained"
  //     aria-label="save" // Add accessible name
  //   >
  //     Submit
  //   </LoadingButton>
  // );
  // }

  render(){
    const {loading} = this.state;
    const {loaded,children,onClick,...others} = this.props;
    return (
    <Box sx={{ position: 'relative', display: 'inline-flex' }}>
      <IconButton onClick={this.onClick} {...others} disabled={loading}>
        {loading ? (
          // Conditionally render CircularProgress when loading
          <CircularProgress 
            size={24} // Adjust the size to fit well within the IconButton
            sx={{
              color: 'primary.main',
              position: 'absolute',
              top: '50%',
              left: '50%',
              marginTop: '-12px', // Center the spinner perfectly
              marginLeft: '-12px', // Center the spinner perfectly
            }}
          />
        ) : (
          // Render the original icon when not loading
          children
        )}
      </IconButton>
    </Box>
  );
  }
}

//export default ProgressDialog;

export default SubmitButton;


// import React, { useState } from 'react';
// import { LoadingButton } from '@mui/lab';

// const LabSaveButton = () => {
//   const [loading, setLoading] = useState(false);

//   const handleClick = () => {
//     setLoading(true);
//     // Async operation handling...
//     setTimeout(() => setLoading(false), 2000);
//   };

  
// };
